import React, { useCallback, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { modalEventListener } from "../../../utils/ModalEventListener";
import { dealerPendingReceiptColumns } from "../../../utils/constant";
import { axios_instance } from "../../../api/axios_instance";
import { Link } from "react-router-dom";
import ContainerLoading from "../../../layouts/ContainerLoading";
import ModalWrapper from "../../../layouts/ModalWrapper";

const DealerPendingReceiptModal = ({
  dealer_id,
  statuses,
  substatuses,
  closeDealerPendingReceiptModal,
  showDealerPendingReceiptModal,
}) => {
  const initialState = { receiptData: [] };
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState(initialState);
  const ref = useRef();
  useEffect(() => {
    return modalEventListener(ref, closeDealerPendingReceiptModal);
  }, [closeDealerPendingReceiptModal]);

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      const receiptResult = await axios_instance({
        url: "/dts/dealerPendingRtoReceipt",
        method: "POST",
        data: { dealer_id },
      });
      setState((prevState) => ({
        ...prevState,
        receiptData: receiptResult.data.receiptData,
      }));
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }, [dealer_id]);

  useEffect(() => {
    if (showDealerPendingReceiptModal) fetchData();
  }, [fetchData]);

  return ReactDOM.createPortal(
    <ModalWrapper
      show={showDealerPendingReceiptModal}
      onClose={closeDealerPendingReceiptModal}
    >
      <div className="modal-wrapper">
        <div className="dealer-pending-receipt-modal-content" ref={ref}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal">
              <span aria-hidden="true" onClick={closeDealerPendingReceiptModal}>
                ×
              </span>
            </button>
            <h4 className="modal-title" id="myModalLabel">
              Dealer Pending Receipt
            </h4>
          </div>
          <div className="modal-body">
            {!isLoading ? (
              <div className="table-responsive">
                <table className="table table-striped jambo_table bulk_action">
                  <thead>
                    <tr className="headings">
                      {dealerPendingReceiptColumns.map((col, idx) => {
                        return (
                          <th
                            width={col.width}
                            className="column-title"
                            key={idx}
                          >
                            {col.title}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody id="dealer-pending-data">
                    {state.receiptData.length ? (
                      state.receiptData.map((data, idx) => {
                        let stage =
                            !data.stage || statuses.length === 0
                              ? "Payment Requested"
                              : statuses[data.stage - 1].label,
                          substage = "Open";

                        if (data.sub_stage && substatuses.length > 0) {
                          if (
                            [3, 4, 12, 14].includes(parseInt(data.sub_stage))
                          ) {
                            substage = "Discrepancy Identified";
                          } else {
                            substage = substatuses.filter(
                              (substatus) =>
                                substatus.id === parseInt(data.sub_stage)
                            )[0].label;
                          }
                        }
                        return (
                          <tr className="even pointer" key={idx}>
                            <td>
                              <Link
                                to={`/payments/details?lead_id=${btoa(
                                  data.finance_lead_id
                                )}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="detailsmodal-link"
                              >
                                {data.finance_lead_id}
                              </Link>
                            </td>
                            <td>{data.rc_done_by}</td>
                            <td>{data.original_docs_collected}</td>
                            <td>{data.disbursed_date}</td>
                            <td>{`${stage}-${substage}`}</td>
                            <td>{data.rcSubStatus}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="6">No record found.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            ) : (
              <ContainerLoading />
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default"
              data-dismiss="modal"
              onClick={closeDealerPendingReceiptModal}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </ModalWrapper>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default DealerPendingReceiptModal;
